import React from 'react';

import styles from "./titleSection.module.scss";
import { renderWithBreaks } from '@utils/translations';

const TitleSection = ({ title, text }) => (
  <div className={styles.titleSection}>
    <h1>{title}</h1>
    <div>{renderWithBreaks(text)}</div>
  </div>
);

export default TitleSection;
